import {WhatsappChannelState} from '../../../../api/proto';
import i18n from '../../../../i18n';


export default function getWhatsappStateTitle(state?: WhatsappChannelState.State | null): string {
  switch (state) {
    case WhatsappChannelState.State.CREATE_CHANNEL:
      return i18n.t('settings_channel_manage_status_authorization');
    case WhatsappChannelState.State.EVENT_LISTENING:
      return i18n.t('settings_channel_manage_status_launch');
    case WhatsappChannelState.State.UNAUTHORIZED:
      return i18n.t('settings_channel_manage_status_error');
    case WhatsappChannelState.State.HISTORY_SYNCING_FAIL:
      return i18n.t('settings_channel_manage_status_history_syncing_fail');

    default:
      return '-';
  }
}